export const APP_DOMAIN = 'https://app.mellow.finance';
